import _ from 'lodash';

import { FeaturePermission } from '../../../constants/feature.permission.helper';
import store from '../../../store';
import {
    OVERVIEW_PANEL_GET_CURRENT,
} from '../../../store/modules/overview-panel/types';
import api from '../../api';
import dataBoard from '../../core/databoard';
import filters from '../../core/filters';
import infoBoard from '../../core/infoboard';
import worldMap from '../../core/map';
import ColorBrewer from '../../core/tools/colorbrewer';
import translate from '../../core/tools/translate';
import environment from '../../environment';
import StoresLayer from "../../layers/AfterSales/StoresAfterSalesLayer";
import Workspace from '../../workspaces';
import { ControlType, Item } from '../../workspaces/item';
import { CoreControl } from '../CoreControl';
import { VectorType } from '../VectorType';
import { FilterTypeEnum } from '../../../enuns/filterType.enum';
import databoard from '../../core/databoard';
import { notify, NOTIFY_TYPE } from '../../shared';
import { ServiceType } from '../../../enuns/AfterSales/serviceArea.enum';
import moment from 'moment';

const LayerControls = (name) => require('../../controls').get(name);

const GetLayer = (name, currentMap = worldMap.getCurrent()) => {
    return require('../../layers/index').default.get(name, currentMap);
};

const LayerInfo = (name) => require('../../info').get(name);

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class StoresAfterSalesControl extends CoreControl {
    constructor(options) {
        super(options);

        this._change = this._change.bind(this);
        this._filterCallback = this._filterCallback.bind(this);
        this._toggleProtectArea = this._toggleProtectArea.bind(this);
        this._toggleSales = this._toggleSales.bind(this);
        this.createFilter = this.createFilter.bind(this);
        this.highlight = this.highlight.bind(this);
        this.unselect = this.unselect.bind(this);
        this.select = this.select.bind(this);
        this.redraw = this.redraw.bind(this);
        this.resetLayer = this.resetLayer.bind(this);
        this.resizeIcon = this.resizeIcon.bind(this);
        this.show = this.show.bind(this);
        this.toggleClientStores = this.toggleClientStores.bind(this);
        this._toggleSearchedAreaFilter = this._toggleSearchedAreaFilter.bind(this);
        this.refreshSearchedAreaFilter = this.refreshSearchedAreaFilter.bind(this);
        this.toggleReported = this.toggleReported.bind(this);
        this.toggleVisibility = this.toggleVisibility.bind(this);
        this.removeProtectArea = this.removeProtectArea.bind(this);
        this.createDashboardServiceArea = this.createDashboardServiceArea.bind(this);

        this._isThisTypeOfArea = null;
        this._instance = null;
    }

    init() {
        const values = {
            id: `layer-${this.options.name.toLowerCase()}`,
            input: 'checkbox',
            label: translate(`Common.${this.options.name}`),
            help: translate(`Help.${this.options.name}`),
            layer: this.getLayer,
            name: this.options.name,
            type: 'vector-points',
            purge: this.resetLayer,
            overview: false,
            filter: {
                enable: true,
                click: this.createFilter
            },
            change: this._change,
            resize: this.isStoreInactive ? false : {
                name: `pinSize${this.options.name}`,
                change: this.resizeIcon,
                type: 'radio'
            },
            tab: () => {
                return $(`#${this.options.name.toLowerCase()}-tab-link`);
            },
            dropdown: [],
            checkbox: {}
        };

        this._tags = {
            tagName: {
                property: 'Name',
                align: 'east',
                size: 10,
                bold: true,
                box: true,
                offsetX: 0,
                offsetY: 40
            },
            tagNumber: {
                name: 'tagNumber',
                property: 'OriginalId',
                align: 'east',
                size: 10,
                bold: true,
                box: true,
                offsetX: 0,
                offsetY: 20
            },
            tagScoreTireRetail: {
                property: 'ScoreTireRetail',
                box: true,
                colorize: true,
                color: 'ScoreTireRetailColor',
                type: 'property',
                bold: true,
                size: 12,
                offsetY: -2,
                offsetX: 0,
                mask: "0.0"
            },
            tagScoreTireTruck: {
                property: 'ScoreTireTruck',
                box: true,
                colorize: true,
                color: 'ScoreTireTruckColor',
                type: 'property',
                bold: true,
                size: 12,
                offsetY: -2,
                offsetX: -34,
                mask: "0.0"
            },
            tagScoreAutoParts: {
                property: 'ScoreAutoParts',
                box: true,
                colorize: true,
                color: 'ScoreAutoPartsColor',
                type: 'property',
                bold: true,
                size: 12,
                offsetY: -2,
                offsetX: -64,
                mask: "0.0"
            }
        };

        const isNetworkLayer = this.getLayer().id === "spatial_networkaftersales_layer";

        values.checkbox[translate('Action.ShowStoresName')] = {
            name: 'tagName',
            change: (checked) => this._toggleLabel(checked, 'tagName'),
            style: {
                change: (tag) => {
                    this._tags.tagName = tag;
                    this._toggleLabel(this.getControls().checkbox.tagName.status, 'tagName');
                },
                options: this._tags.tagName
            }
        };

        if (this.options.name !== 'StoreInactiveAfterSales') {
            values.checkbox[translate('Action.ShowStoresNumber')] = {
                name: 'tagNumber',
                change: (checked) => this._toggleLabel(checked, 'tagNumber'),
                style: {
                    change: (tag) => {
                        this._tags.tagNumber = tag;
                        this._toggleLabel(this.getControls().checkbox.tagNumber.status, 'tagNumber');
                    },
                    options: this._tags.tagNumber
                }
            };
        }

        if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_NETWORK.showScoreAutoParts) && isNetworkLayer)
            values.checkbox[translate('Action.ShowScoreAutoParts')] = {
                name: 'tagScoreAutoParts',
                change: (checked) => this._toggleLabel(checked, 'tagScoreAutoParts'),
                style: {
                    change: (tag) => {
                        this._tags.tagScoreAutoParts = tag;
                        this._toggleLabel(this.getControls().checkbox.tagScoreAutoParts.status, 'tagScoreAutoParts');
                    },
                    options: this._tags.tagScoreAutoParts
                }
            };

        if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_NETWORK.showScoreTireTruck) && isNetworkLayer)
            values.checkbox[translate('Action.ShowScoreHeavyTires')] = {
                name: 'tagScoreTireTruck',
                change: (checked) => this._toggleLabel(checked, 'tagScoreTireTruck'),
                style: {
                    change: (tag) => {
                        this._tags.tagScoreTireTruck = tag;
                        this._toggleLabel(this.getControls().checkbox.tagScoreTireTruck.status, 'tagScoreTireTruck');
                    },
                    options: this._tags.tagScoreTireTruck
                }
            };

        if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_NETWORK.showScoreTireRetail) && isNetworkLayer)
            values.checkbox[translate('Action.ShowScoreRetailTires')] = {
                name: 'tagScoreTireRetail',
                change: (checked) => this._toggleLabel(checked, 'tagScoreTireRetail'),
                style: {
                    change: (tag) => {
                        this._tags.tagScoreTireRetail = tag;
                        this._toggleLabel(this.getControls().checkbox.tagScoreTireRetail.status, 'tagScoreTireRetail');
                    },
                    options: this._tags.tagScoreTireRetail
                }
            };

        if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_NETWORK.showProtectArea) && this.options.name !== 'StoreInactiveAfterSales') {
            values.checkbox[translate('Action.ShowProtectArea')] = {
                name: `protectAreas`,
                change: this._toggleProtectArea,
            };
        }

        if (this.options.name !== 'StoreInactiveAfterSales') {
            values.checkbox[translate('Action.LimitToSearchedArea')] = {
                name: 'searchedArea',
                change: this._toggleSearchedAreaFilter,
            };
        }

        if (!this._instance) {
            this._instance = new VectorType(values);
        }
    }

    _getLayerName() {
        const layerName = this.getLayer().id === 'spatial_networkaftersales_layer'
            ? 'NetworkAfterSales'
            : 'CompetitorsAfterSales';

        return layerName;
    }

    _getProtectedAreaLayer() {
        const layerName = this._getLayerName();
        const protectAreaLayer = layerName === 'NetworkAfterSales'
            ? GetLayer('ProtectAreaNetworkAfterSales')
            : GetLayer('ProtectAreaCompetitorsAfterSales');

        return protectAreaLayer;
    }

    _toggleProtectArea(checked) {
        const layerName = this._getLayerName();
        const protectAreaLayer = this._getProtectedAreaLayer();
        const storeType = layerName === 'NetworkAfterSales' ? 1 : 2;
        if (checked && this.getControls().switch.onOff.status) {
            protectAreaLayer.onLoad(layerName, storeType);
        } else {
            protectAreaLayer.offLoad();
        }
    }

    removeProtectArea() {
        const protectAreaLayer = this._getProtectedAreaLayer();
        protectAreaLayer.removeProtectArea();
    }

    _change(e) {
        super._change(e);
        this._setFilterButtonVisibility(e.checked);
        this.refreshSearchedAreaFilter();

        if (!e.checked) {
            this.getLayer().setOptions({ legend: false });
            LayerControls('ServiceAreaAfterSales')._change(e.checked);
            databoard.reset();
            databoard.hide();
        }

        if (this.getControls().checkbox.protectAreas) {
            this._toggleProtectArea(this.getControls().checkbox.protectAreas.status);
        }

        Workspace.addAction(new Item(`#${$(e).prop('id')}`, e.checked, ControlType.ICheckBox));
    }

    _getLayerTag() {
        if (!this.getControls().checkbox) return undefined;

        const tags = [];

        if (this.getControls().checkbox.tagName && this.getControls().checkbox.tagName.status) {
            tags.push({ ...this._tags.tagName });
        }

        if (this.getControls().checkbox.tagNumber && this.getControls().checkbox.tagNumber.status) {
            tags.push({ ...this._tags.tagNumber });
        }

        if (this.getControls().checkbox.tagScoreTireRetail && this.getControls().checkbox.tagScoreTireRetail.status) {
            tags.push({ ...this._tags.tagScoreTireRetail });
        }

        if (this.getControls().checkbox.tagScoreTireTruck && this.getControls().checkbox.tagScoreTireTruck.status) {
            tags.push({ ...this._tags.tagScoreTireTruck });
        }

        if (this.getControls().checkbox.tagScoreAutoParts && this.getControls().checkbox.tagScoreAutoParts.status) {
            tags.push({ ...this._tags.tagScoreAutoParts });
        }

        return tags.length === 1 ? tags[0] : tags;
    }

    _setLabel() {
        this.getLayer().setOptions({ tag: this._getLayerTag() });
    }

    _toggleLabel(checked, name) {
        api.general.log.action(environment._getContextEnum(this.options.name), `Show Label ${name}`, '');

        const currentTags = Array.isArray(this.getLayer().options.tag)
            ? [...this.getLayer().options.tag]
            : (this.getLayer().options.tag ? [this.getLayer().options.tag] : []);

        if (checked) {
            const newTag = this._tags[name];
            const updatedTags = [...currentTags, newTag];
            this.getLayer().setOptions({ tag: updatedTags.length === 1 ? updatedTags[0] : updatedTags });
        } else {
            const updatedTags = currentTags.filter(tag => tag.property !== this._tags[name].property);
            this.getLayer().setOptions({ tag: updatedTags.length === 1 ? updatedTags[0] : updatedTags });
        }

        if (this.getLayer().visible()) {
            this.getLayer().reload();
        }
    }

    _toggleSales(checked) {
        const { options, id } = this.getLayer();
        const { symbology } = options;

        api.general.log.action(environment._getContextEnum(this.options.name), 'Show VMM', '');

        if (!this.filterOptions) {
            this.filterOptions = {};
        }

        if (checked) {
            symbology.heat.theme = ColorBrewer.getHeatColors(ColorBrewer.RED_YELLOW_BLUE);
            symbology.heat.property = 'MediaMensal';
            this.filterOptions[`showVMM${this.options.name}`] = true;
        } else {
            symbology.heat.theme = ColorBrewer.getHeatColors(ColorBrewer.RED_YELLOW_GREEN);
            symbology.heat.property = undefined;
            this.filterOptions[`showVMM${this.options.name}`] = false;
        }

        filters.updateControls(this.filterOptions);
        filters.reloadFilters(worldMap.getCurrent()._id, this.filterOptions);
        this.getLayer().setOptions({ symbology, optFilters: this.filterOptions });
        this._reloadIfNeeded();
    }

    _reloadIfNeeded() {
        this._setLabel();
        if (this.check() && this.getLayer().visible()) {
            this.getLayer().reload();
        }
    }

    _view(values) {
        LayerInfo('StoresInfoAfterSales').create(values, this.options.name);
    }

    _toArray(t) {
        if (/, /.test(String(t))) {
            return String(t).split(', ');
        } else {
            return String(t).split(',');
        }
    }

    _filterCallback(values) {
        const brandsValue = values.brands && values.brands.value ? values.brands.value : [];
        const brandsSelected = _.isArray(brandsValue) ? brandsValue : [brandsValue];

        const selectedFilters = {
            ServiceTypeId: {
                type: FilterTypeEnum.Include,
                data: (values.serviceTypes && _.isArray(values.serviceTypes.value) && _.size(values.serviceTypes.value)) ? values.serviceTypes.value : []
            },
            StateAcronym: values.stateAcronym && values.stateAcronym.value ? values.stateAcronym.value : [],
            // Brands e propriedade array na feature: uma loja pode ter varias marcas (Gig.LojaMarca).
            // Precisa do Include com ids numericos, como ServiceTypeId acima; o ramo de igualdade
            // compara o array inteiro convertido em texto e nunca casa com loja multimarca.
            Brands: {
                type: FilterTypeEnum.Include,
                data: brandsSelected.map(Number)
            },
            NetworkId: values.networks && values.networks.value ? values.networks.value : [],
            NetworkTypeId: values.networkTypes && values.networkTypes.value ? values.networkTypes.value : [],
            NetworkStoreSize: values.classifications && values.classifications.value ? values.classifications.value : [],
            DealerTypeId: values.dealerTypes && values.dealerTypes.value ? values.dealerTypes.value : [],
        };

        selectedFilters.NetworkId = _.isArray(selectedFilters.NetworkId)
            ? selectedFilters.NetworkId.map(x => x.toString())
            : [selectedFilters.NetworkId.toString()];

        selectedFilters.NetworkTypeId = _.isArray(selectedFilters.NetworkTypeId)
            ? selectedFilters.NetworkTypeId.map(x => x.toString())
            : [selectedFilters.NetworkTypeId.toString()];

        selectedFilters.DealerTypeId = _.isArray(selectedFilters.DealerTypeId)
            ? selectedFilters.DealerTypeId.map(x => x.toString())
            : [selectedFilters.DealerTypeId.toString()];

        selectedFilters.NetworkStoreSize = _.isArray(selectedFilters.NetworkStoreSize)
            ? selectedFilters.NetworkStoreSize.map(x => x.toString())
            : [selectedFilters.NetworkStoreSize.toString()];

        const filterMetadata = {
            ServiceTypeId: {
                total: values.serviceTypes && values.serviceTypes.metadata && values.serviceTypes.metadata.total,
            },
            StateAcronym: {
                total: values.stateAcronym && values.stateAcronym.metadata && values.stateAcronym.metadata.total,
            },
            Brands: {
                total: values.brands && values.brands.metadata && values.brands.metadata.total,
            },
            NetworkId: {
                total: values.networks && values.networks.metadata && values.networks.metadata.total,
            },
            NetworkTypeId: {
                total: values.networkTypes && values.networkTypes.metadata && values.networkTypes.metadata.total,
            },
            NetworkStoreSize: {
                total: values.classifications && values.classifications.metadata && values.classifications.metadata.total,
            },
            DealerTypeId: {
                total: values.dealerTypes && values.dealerTypes.metadata && values.dealerTypes.metadata.total,
            },
        };

        this.getLayer().setOptions({ filterMetadata });

        const filter = this.getLayerFilters();
        _.forEach(selectedFilters, (val, key) => {
            if (_.size(val) || (_.isBoolean(val))) {
                filter.properties[key] = val;
            } else {
                delete filter.properties[key];
            }
        });

        this.setLayerFilters(filter);
        api.general.log.action(environment._getContextEnum(this.options.name), 'Filtro', JSON.stringify(filter));

        if (!this.check()) {
            this.check(true);
        }

        this.reloadProtectArea();
    }

    reloadProtectArea() {
        if (this.getControls().checkbox.protectAreas && this.getControls().checkbox.protectAreas.status) {
            const protectAreaLayer = this._getProtectedAreaLayer();
            protectAreaLayer.reloadProtectedArea();
        }
    }

    _setFilterButtonVisibility(state) {
        try {
            Object.keys(this.getControls().button).forEach(item => {
                if (this.getControls().button[item].input) {
                    this.getControls().button[item].input.enable(state);
                }
                this.getControls().button[item].enable = state;
            });

            if (store.getters[OVERVIEW_PANEL_GET_CURRENT] === this.options.name && !state) {
                dataBoard.hide();
                delete this._overviewFeatures;
            }
        } catch (err) {
            console.error(err);
        }

        state ? this.createFilter() : filters.close();
    }

    createFilter() {
        this.filterOptions = {
            ...this.filterOptions,
            ... {
                id: `${_.kebabCase(this.options.name)}-filter-id`,
                label: translate(`Common.${this.options.name}`),
                type: _.lowerCase(this.options.name),
                onSubmit: this._filterCallback
            }
        };

        filters.create(this.filterOptions);

        this.setDefaultFilters();
    }

    setDefaultFilters() {
        if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_NETWORK.filterNetworkType)) {
            const sourceNetworks = environment.get('CONFIG.FILTERS.CLIENT_NETWORKS');
            const defaultFilters = {
                networks: { "metadata": { "name": "networks", "text": "name", "value": "id", "properties": ["id", "name"] }, "value": [sourceNetworks[0].networkId], "text": [sourceNetworks[0].networkName] }
            };
            filters.set(
                `${_.kebabCase(this.options.name)}-filter-id`,
                worldMap.getCurrent()._id,
                defaultFilters
            );
            this._filterCallback(defaultFilters);
        }
    }

    getLayerFilters() {
        const filter = (this.getLayer().options.filter || {});

        if (!filter.properties) filter.properties = {};

        return filter;
    }

    setLayerFilters(filter) {
        this.getLayer().setOptions({ filter });

        if (this.check() && this.getLayer().visible()) {
            this.getLayer().reload();
        }
    }

    // Geometrias da area pesquisada, desenhada pela busca na camada Location.
    // So poligono serve para recortar pontos, entao ponto e linha sao descartados.
    _getSearchedAreaShapes() {
        if (!environment.get('LOCALE.FILTERED')) return null;

        try {
            const shapes = GetLayer('Location')
                .getFeatures()
                .filter(feature => feature.geometry
                    && ['Polygon', 'MultiPolygon'].includes(feature.geometry.type));

            return shapes.length ? shapes : null;
        } catch (error) {
            console.log('WARNING: Location layer not available');
            return null;
        }
    }

    _toggleSearchedAreaFilter(checked) {
        const filter = this.getLayerFilters();
        const shapes = checked ? this._getSearchedAreaShapes() : null;

        if (shapes) {
            filter.shape = shapes;
        } else {
            delete filter.shape;
        }

        this.setLayerFilters(filter);

        // A protect area deriva do recorte da camada de lojas, mas so recalcula no moveend.
        // Sem isso ela fica com as areas do recorte anterior, como o _filterCallback ja trata.
        this.reloadProtectArea();
    }

    // Chamado pela busca sempre que LOCALE.FILTERED muda, e ao ligar a camada.
    // Sem area no mapa o check nao tem o que recortar: desmarca, para a camada voltar
    // a mostrar tudo, e desabilita. Com o check ligado e outra area pesquisada, troca
    // o recorte pela geometria nova.
    refreshSearchedAreaFilter() {
        let controls;

        // O registro do sidebar so existe depois do sidebar.setControls, que o bootstrap
        // agenda para depois dos init(). Antes disso getControls lanca, e nao ha check
        // para atualizar.
        try {
            controls = this.getControls();
        } catch (error) {
            return;
        }

        const control = controls && controls.checkbox && controls.checkbox.searchedArea;

        if (!control) return;

        const hasLocale = !!environment.get('LOCALE.FILTERED');

        if (control.status) {
            if (hasLocale) {
                this._toggleSearchedAreaFilter(true);
            } else {
                control.input.iCheck('uncheck');
            }
        }

        control.input.iCheck(hasLocale ? 'enable' : 'disable');
    }

    toggleClientStores(checked) {
        const filter = this.getLayerFilters();

        if (checked) {
            filter.properties.IdLojaCliente = environment.get('CONFIG.FILTERS.CUSTOMERS_STORES');
        } else {
            delete filter.properties.IdLojaCliente;
        }

        this.setLayerFilters(filter);
    }

    resizeIcon(value) {
        const { options } = this.getLayer();
        const { symbology } = options;
        const imgSize = {
            sm: '_sm',
            xs: '_xs'
        };

        const sizes = [
            { size: 'large', imgSuffix: '', iconSize: [50, 64], iconAnchor: [25, 60], labelAnchor: [25, -32] },
            { size: 'medium', imgSuffix: imgSize.sm, iconSize: [38, 48], iconAnchor: [19, 48], labelAnchor: [19, -24] },
            { size: 'small', imgSuffix: imgSize.xs, iconSize: [28, 28], iconAnchor: [14, 14], labelAnchor: [14, 0] }
        ];

        const { imgSuffix, iconSize, iconAnchor, labelAnchor, size } = sizes.find(x => x.size === value);
        api.general.log.action(environment._getContextEnum(this.options.name), `Mudou Tam. Icone: ${size}`);

        symbology.style.icon = {
            getUrl: store => {
                const applyUrl = StoresLayer.getApplicatorUrlIcon(this.options.name);
                const url = applyUrl(store);
                return url;
            },
            imgSuffix,
            iconSize,
            iconAnchor,
            labelAnchor
        };

        this.getLayer().setOptions({ symbology });
        if (this.check() && this.getLayer().visible()) {
            return this.getLayer().reload();
        }
    }

    toggleReported(checked) {
        const { params } = this.getLayer().options.remote;
        params.LoadReportedStores = checked;
        this.getLayer().setOptions({
            remote: {
                params
            }
        });
        if (this.check() && this.getLayer().visible()) {
            this.getLayer().redraw();
        }
    }

    resetLayer() {
        const filter = {};
        if (!filter.properties)
            filter.properties = {};
        this.setLayerFilters(filter);
        this.getLayer().redraw();
    }

    redraw() {
        $(`#${this.options.name.toLowerCase()}-tab-link`).trigger('click');
        this.getLayer().redraw();
    }

    show(options = {}, features = this.getLayer().getCurrentFeatures()) {
        if ($(`#${this.options.name.toLowerCase()}-collapse`).length === 0 || options.refresh) {
            if (options.empty) {
                this._view(null);
            } else {
                this._view(features, this.options.context);
            }
        }
        if (options.show) {
            infoBoard.open();
            $(`#${this.options.name.toLowerCase()}-tab-link`).trigger('click');
            if (options.id) {
                const title = $(`#${this.options.name.toLowerCase()}-title-${options.id}`);
                return setTimeout(() => {
                    if (title[0] && !title[0].isOpen) {
                        title.trigger('select');
                    }
                }, 300);
            }
        }
    }

    toggleVisibility(id, layer) {
        this._instance.toggleVisibility(id, layer);
    }

    highlight(marker, event) {
        const map = worldMap.getCurrent();

        map.eachLayer(layer => {
            if (layer.options.icon && layer.options.icon.options && layer.options.icon.options.iconUrl) {
                this._instance.unselect(layer, event);
            }
        });

        this._instance.highlight(marker, event);
    }

    select(marker, type) {
        this._instance.select(marker, type);
    }

    unselect(marker, type) {
        this._instance.unselect(marker, type);
    }

    _treatDealersWithSameName(sales) {
        sales = sales.map((s, idx) => {
            const dealersSameName = sales.filter(x => x.Dealer === s.Dealer);

            if (dealersSameName.length > 1) {
                s.Dealer = Array.from({ length: idx }).reduce(acc => acc + ' ', s.Dealer);
            }

            return s;
        });
    }

    createDashboardServiceArea(feature, areaCheck) {
        const check = areaCheck || LayerControls('ServiceAreaAfterSales').hasServiceAreaForStore(feature.properties.Id);

        if (!check.hasAny) {
            return notify(NOTIFY_TYPE.ERROR, 'Gere uma área de influência para visualizar os indicadores associados.!');
        }

        const defaultType = check.hasReal ? ServiceType.Real : ServiceType.Theoretical;

        if (this._isThisTypeOfArea === null || areaCheck) {
            this._isThisTypeOfArea = defaultType;
        }

        const showDataBoard = (id, idServiceArea) => {
            const baseTitle = this._isThisTypeOfArea === ServiceType.Theoretical
                ? `Indicadores Área de Influência (Potencial) - ${feature.properties.Name}`
                : `Indicadores Área de Influência (Real) - ${feature.properties.Name}`;

            const title = baseTitle + this.buildPeriod();

            api.afterSales.get.serviceArea.indicators(id, idServiceArea)
                .then(data => {
                    data.title = title;
                    data.nameFile = `${environment.get('CONFIG.CLIENT')}_${baseTitle}_v${moment().format('YYYYMMDD')}`;
                    data.convertTable = false;
                    data.scrollable = true;
                    data.sortable = true;
                    data.size = '50%';
                    data.buttons = {
                        fullscreen: true,
                        export: true,
                    };

                    if (check.hasReal && check.hasTheoretical) {
                        data.filters = {
                            inputs: [
                                {
                                    id: 0,
                                    select: true,
                                    multiSelect: false,
                                    type: data.type,
                                    index: this._isThisTypeOfArea === ServiceType.Real ? 0 : 1,
                                    values: [
                                        { text: 'Real', value: ServiceType.Real },
                                        { text: 'Potencial', value: ServiceType.Theoretical }
                                    ],
                                    visible: true,
                                    change: (e) => {
                                        this._isThisTypeOfArea = parseInt(e.sender.value(), 10);
                                        showDataBoard(feature.properties.Id, this._isThisTypeOfArea);
                                    }
                                }
                            ]
                        };
                    }

                    databoard.show(data);
                });
            };

        showDataBoard(feature.properties.Id, this._isThisTypeOfArea);
    }

    buildPeriod() {
        const period = environment.get('CONFIG.FILTERS.SALES_PERIOD');

        if (!period || !period.yearEnd || !period.monthEnd) {
            return '';
        }

        const end = moment({
            year: period.yearEnd,
            month: period.monthEnd - 1,
            day: 1
        }).endOf('month');

        const start = end.clone()
            .subtract(11, 'months')
            .startOf('month');

        const startLabel = start.format('MMM/YYYY');
        const endLabel = end.format('MMM/YYYY');

        return ` - Últimos 12 Meses (${startLabel} - ${endLabel})`;
    }
}

export default StoresAfterSalesControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/AfterSales/StoresAfterSalesControl.js